// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"1e89b1b2","238":"954a7876"}[chunkId] + ".chunk.js";
};